// app/frontend/entrypoints/layout-entry.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import Layout from '../components/Layout';
import { MantineProvider } from '@mantine/core';

interface Props {
  children?: React.ReactNode;
}

console.log('🔥 LAYOUT ENTRY COMPONENT LOADED');

document.addEventListener('turbo:load', () => {
  const layoutContainer = document.getElementById('react-layout');

  if (layoutContainer) {
    const children = layoutContainer.innerHTML;
    layoutContainer.innerHTML = '';

    const root = createRoot(layoutContainer);
    root.render(
      <MantineProvider>
        <Layout>
          <div dangerouslySetInnerHTML={{ __html: children }} />
        </Layout>
      </MantineProvider>,
    );
  } else {
    console.error('❌ Could not find #react-layout container');
  }
});
